import { BCMSRecord, useGlobalController, useParams, Workflow } from "@bcm-dev/bcms-vite";
import { Biller } from "model";

import ConfirmEBillPage from "compid/pages/ConfirmEBillPage";
import RequestEBillPage from "compid/pages/RequestEBillPage";

const steps = {
    "/requestEBill" : <RequestEBillPage />,
    "/confirmEBill" : <ConfirmEBillPage />
};

export default function RequestEBillWorkflow(props) {
    const controller = useGlobalController();
    const { billerID, stepID } = useParams();

    const value = getDefaultRequest(controller, billerID);
    return <Workflow value={ value } steps={ Object.values(steps) } step={ stepID } />
}

export const getWorkflowSteps = () => steps;

export const getDefaultRequest = (controller, billerID) => {
    BCMSRecord.globalControllerFor([ Biller ], controller);
    const biller = billerID === undefined ? Biller.firstBiller(controller.state) : Biller.initByID(billerID);

    return { biller };
}